import MyFormik from "../../components/Form/MyFormik.tsx";
import RoleUtilisateur, {
  getInitialValues,
  prepareVariables,
  validationSchemaCreate,
} from "./RoleUtilisateur.tsx";

const CreateRoleUtilisateur = () => {
  return (
    <MyFormik
      initialValues={getInitialValues(null)}
      validationSchema={validationSchemaCreate}
      isPost={true}
      submitUrl={`/api/utilisateurs/create`}
      prepareVariables={(values) => prepareVariables(null, values)}
    >
      <RoleUtilisateur isNew={true} />
    </MyFormik>
  );
};

export default CreateRoleUtilisateur;
